var map = {
	"./AOffer/Ltr.css": 1059,
	"./AOffer/Rtl.css": 1060,
	"./ASKERI/Ltr.css": 1061,
	"./ASKERI/Rtl.css": 1062,
	"./Swiftee/Ltr.css": 1063,
	"./Swiftee/Rtl.css": 1064,
	"./Swiftee/colors.css": 1065,
	"./default/Ltr.css": 623,
	"./default/Rtl.css": 624,
	"./default/colors.css": 625,
	"./latreqi/Ltr.css": 1066,
	"./latreqi/Rtl.css": 1067,
	"./sassColors/Anypoint.css": 1068,
	"./sassColors/BeyondDelivery.css": 1069,
	"./sassColors/CouriersExpress.css": 1070,
	"./sassColors/EaglePost.css": 1071,
	"./sassColors/Geshikt.css": 1072,
	"./sassColors/Jora.css": 1073,
	"./sassColors/Kiosken.css": 1074,
	"./sassColors/Kwikr.css": 1075,
	"./sassColors/Maydaycourier.css": 1076,
	"./sassColors/Ondelivery.css": 1077,
	"./sassColors/ParcelBeep.css": 1078,
	"./sassColors/PinkExpress.css": 1079,
	"./sassColors/Privitrides.css": 1080,
	"./sassColors/Reflexcourier.css": 1081,
	"./sassColors/Snapbox.css": 1082,
	"./sassColors/Solutions1000.css": 1083,
	"./sassColors/Swishr.css": 1084,
	"./sassColors/TheTruckingForme.css": 1085,
	"./sassColors/landeber.css": 1086,
	"./sassColors/mannaev.css": 1087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1058;